import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { setLanguageTag } from '../../../session/actions/set-language-tag';
import { isMemberSignedIn } from '../../selectors/member/is-member-signed-in';
import { loyaltyDomainStore } from '../../store';
import { temporaryLoyaltyDomainStore } from '../../temporary-store/store';
import { assignMemberRelatedData } from '../../utils/assign-member-related-data';
export const loadMember = async (reloadCachedData = false) => {
    if (!isMemberSignedIn()) {
        throw Error('Cannot load member when user is not signed in.');
    }
    const state = temporaryLoyaltyDomainStore.data.member;
    return await loadDataFromApi({
        api: ocapiClient.instance.v1.loyalty.members.getCurrent,
        state,
        cacheDuration: getCacheDuration('member'),
        reloadCachedData,
        onSuccess
    });
};
const onSuccess = (response, cacheDuration) => {
    const { member, relatedData } = response;
    assignMemberRelatedData(relatedData, cacheDuration);
    // Persist the member hash for CXM purposes.
    loyaltyDomainStore.data.memberHash = member.hash;
    // Update the language tag if set.
    const { languageTag } = member.personalDetails.preferences;
    if (languageTag) {
        setLanguageTag(languageTag);
    }
    return member;
};
//# sourceMappingURL=load-member.js.map